// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4301":"63780c83","4660":"375214df","4814":"3070a0f7","8718":"48e07b31","8847":"7b672fd0"}[chunkId] + ".css";
};